import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Send, Facebook, Instagram, Loader2 } from "lucide-react";

const DEFAULT_POST = { content: "", media_url: "", media_type: "image", platforms: ["instagram", "facebook"] };

export function NewPostDialog({ open, onOpenChange, saving, onCreatePost }) {
  const [newPost, setNewPost] = useState(DEFAULT_POST);

  const togglePlatform = (platform) => {
    setNewPost(prev => {
      const platforms = prev.platforms.includes(platform)
        ? prev.platforms.filter(p => p !== platform)
        : [...prev.platforms, platform];
      return { ...prev, platforms };
    });
  };

  const handleCreate = () => {
    onCreatePost(newPost, () => {
      setNewPost(DEFAULT_POST);
      onOpenChange(false);
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Send className="w-5 h-5 text-pink-600" />
            Criar Novo Post
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <label className="text-xs font-medium text-muted-foreground">Plataformas</label>
            <div className="flex gap-2 mt-1">
              <Button
                type="button"
                variant={newPost.platforms.includes("facebook") ? "default" : "outline"}
                size="sm"
                onClick={() => togglePlatform("facebook")}
                className={newPost.platforms.includes("facebook") ? "bg-blue-600 hover:bg-blue-700" : ""}
              >
                <Facebook className="w-4 h-4 mr-1" /> Facebook
              </Button>
              <Button
                type="button"
                variant={newPost.platforms.includes("instagram") ? "default" : "outline"}
                size="sm"
                onClick={() => togglePlatform("instagram")}
                className={newPost.platforms.includes("instagram") ? "bg-gradient-to-r from-pink-600 to-purple-600" : ""}
              >
                <Instagram className="w-4 h-4 mr-1" /> Instagram
              </Button>
            </div>
          </div>
          <div>
            <label className="text-xs font-medium text-muted-foreground">Conteúdo</label>
            <Textarea
              value={newPost.content}
              onChange={e => setNewPost(prev => ({ ...prev, content: e.target.value }))}
              placeholder="Escreva o texto do seu post..."
              rows={4}
            />
          </div>
          <div>
            <label className="text-xs font-medium text-muted-foreground">URL da Mídia (opcional)</label>
            <Input
              value={newPost.media_url}
              onChange={e => setNewPost(prev => ({ ...prev, media_url: e.target.value }))}
              placeholder="https://..."
            />
          </div>
          <div>
            <label className="text-xs font-medium text-muted-foreground">Tipo de Mídia</label>
            <Select value={newPost.media_type} onValueChange={v => setNewPost(prev => ({ ...prev, media_type: v }))}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="image">Imagem</SelectItem>
                <SelectItem value="video">Vídeo/Reels</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button
            onClick={handleCreate}
            disabled={saving || !newPost.content.trim()}
            className="bg-gradient-to-r from-pink-600 to-purple-600"
          >
            {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            <Send className="w-4 h-4 mr-2" /> Publicar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
